import React from "react";
import {Button} from "../../../components/Button";
import {strings} from "../../../strings/strings";

export const NoProductMessage = ({homeUrl}) => {
    return (
        <>
            <h1>
                {strings.reglamentErrorMessage3}
            </h1>
            <Button label={strings.toMainPage}
                    onClickListener={() => window.location.replace(homeUrl)}/>
        </>
    )
};